import { logStatsigEvent } from '@libs/feature-toggle';

import type { BaseMetadata } from '../../models';

// NOTE: This function exists to allow for mocking it in unit tests
export function logStatsigEventWrapper(
  eventName: string,
  eventValue?: string | number,
  eventMetadata?: Record<string, string>,
  baseMetadata?: BaseMetadata
): void {
  const metadata = eventMetadata
    ? { ...baseMetadata, ...eventMetadata }
    : baseMetadata;

  logStatsigEvent(eventName, eventValue, metadata);
}
